<template>
  <v-container fluid>
    <v-row>
      <!-- FIRST COLUMN: FORM + SELECTED PROJECT -->
      <v-col
        class="px-6"
        md="5"
        lg="4"
      >
        <v-container
          fluid
          class="pt-0 mt-0"
        >
          <v-row>
            <!-- FORM NEW PROJECT -->
            <form-new-project
              ref="newProject"
              :show-template="false"
            />
          </v-row>
          <v-row>
            <v-col xs="12">
              <!-- SELECTED PROJECT -->
              <template-card
                v-if="currentTemplate.width > 0 && currentTemplate.height > 0"
                :card-data="currentTemplate"
              >
                {{ currentTemplate.name }}
              </template-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              xs="12"
              class="text-center my-2"
            >
              <v-btn @click="newProject">
                {{ $t("profile.sections.common.create") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <!-- SECOND COLUMN: PROJECT & TEMPLATE GRID LIST -->
      <v-col
        id="right-panel"
        md="7"
        lg="8"
      >
        <!-- PROJECT GRID LIST -->
        <v-row>
          <v-col class="h6">
            {{ $t("navbar.project") }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <project-grid @project-selected="defineSelected" />
          </v-col>
        </v-row>
        <!-- TEMPLATE LIST -->
        <v-row>
          <v-col class="h6">
            {{ $t("project.template") }}
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <template-list />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import formNewProject from "./Form/FormNewProject";
import projectGrid from "./ProjectPage/ProjectGrid";
import templateList from "./ProjectPage/TemplateList";
import templateCard from "./Common/TemplateCard";

export default {
  components: {
    formNewProject,
    projectGrid,
    templateList,
    templateCard,
  },
  data() {
    return {
      currentTemplate: {
        name: "",
        width: 0,
        height: 0,
      },
    };
  },
  created() {
    document.title = this.$t("navbar.project") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.project"));
  },
  methods: {
    newProject() {
      const name = this.$refs.newProject.pName;
      let projectData = {
        x: 0,
        y: 0,
        width: parseInt(this.$refs.newProject.pWidth),
        height: parseInt(this.$refs.newProject.pHeight),
        scale: {
          x: 1,
          y: 1,
        },
      };

      // if no value on width or height we take the current template
      if (isNaN(projectData.width)) {
        projectData.width = this.currentTemplate.width;
      }
      if (isNaN(projectData.height)) {
        projectData.height = this.currentTemplate.height;
      }

      // Before creating a project with no dimensions check if more than zero
      if (projectData.width > 0 && projectData.height > 0) {
        this.$store.dispatch("new", { name: name, properties: projectData });
        this.$router.push({ path: "/project/1" });
      }
    },
    defineSelected(project) {
      this.currentTemplate = project;
      this.$refs.newProject.pWidth = this.currentTemplate.width;
      this.$refs.newProject.pHeight = this.currentTemplate.height;
    },
  },
};
</script>

<style>
#right-panel {
  max-height: calc(100vh - 64px);
  overflow-x: auto;
}
</style>
